import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { parentLinks } from "../../../data/parent-menu";
import { ListItem } from "../list-item/list-item";
import styles from "./how-cinch-works-menu.module.css";
export var HowCinchWorksListItems = function(param) {
    var navItems = param.navItems, handleTrackEvent = param.handleTrackEvent, shouldShowStoreMegaNav = param.shouldShowStoreMegaNav;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: navItems.filter(filterCopy(shouldShowStoreMegaNav)).map(function(listItem) {
            return /*#__PURE__*/ _jsx("li", {
                className: styles.listItem,
                children: /*#__PURE__*/ _jsx(ListItem, {
                    label: listItem.label,
                    ariaLabel: listItem.label,
                    href: listItem.href,
                    handleClickEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            action: listItem.label,
                            label: parentLinks.HOWCINCHWORKS,
                            value: listItem.label
                        });
                    }
                }, listItem.label)
            }, listItem.label);
        })
    });
};
/**
 * a Curried function to help simplify the filter function
 * @param shouldShowStoreMegaNav
 * @returns {(snippet: NavLink) => boolean} filterFn
 */ export function filterCopy(shouldShowStoreMegaNav) {
    return function(param) {
        var label = param.label;
        if (label === "Visit our stores") {
            return shouldShowStoreMegaNav;
        }
        return true;
    };
}
